/* Sleepiti v2 (WAO-105). Small helpers on top of Horizon; never replaces Horizon's product form or cart. */
(() => {
  const reduce = () => window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const buyBox = () => document.querySelector('product-information, .product-information, #product-purchase');
  const addButton = () => {
    const box = buyBox();
    return box && box.querySelector('add-to-cart-component button, button[name="add"], [type="submit"][ref="addToCartButton"]');
  };

  // "Back to pack options" links from content sections scroll to Horizon's buy box.
  document.addEventListener('click', (event) => {
    const link = event.target.closest('[data-back-to-pack], a[href="#product-purchase"]');
    if (!link) return;
    const box = buyBox();
    if (!box) return;
    event.preventDefault();
    box.scrollIntoView({ behavior: reduce() ? 'auto' : 'smooth', block: 'start' });
    const field = box.querySelector('variant-picker input:checked, variant-picker input, h1');
    if (field) field.focus({ preventScroll: true });
  });

  // Sticky add-to-cart: shown once Horizon's own button scrolls out of view; clicks the real button.
  function initSticky(bar) {
    const btn = addButton();
    if (!btn || !('IntersectionObserver' in window)) return;
    const priceEl = bar.querySelector('[data-sticky-price]');
    const stickyBtn = bar.querySelector('[data-sticky-add]');
    const syncPrice = () => {
      const p = buyBox()?.querySelector('product-price, .price');
      if (p && priceEl) priceEl.textContent = p.innerText.trim().split('\n')[0];
      if (stickyBtn) stickyBtn.disabled = btn.disabled;
    };
    new IntersectionObserver(([entry]) => {
      const below = entry.boundingClientRect.top < 0;
      bar.classList.toggle('is-visible', !entry.isIntersecting && below);
      bar.setAttribute('aria-hidden', String(!bar.classList.contains('is-visible')));
      syncPrice();
    }).observe(btn);
    stickyBtn?.addEventListener('click', () => { syncPrice(); if (!btn.disabled) btn.click(); });
    document.addEventListener('variant:update', syncPrice);
    document.addEventListener('change', (e) => { if (e.target.closest('variant-picker')) setTimeout(syncPrice, 400); });
  }

  const boot = (scope = document) => scope.querySelectorAll('[data-sl-sticky-atc]').forEach(initSticky);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => boot());
  else boot();
  document.addEventListener('shopify:section:load', (e) => boot(e.target));
})();
